import React from "react";
import { Box, Typography, CssBaseline, Container } from "@mui/material";
import { motion } from "framer-motion";

import Navbar from "../../components/Navbar";
import PostLoginFooter from "../../components/PostLoginFooter";
import GlobalSidebar from "../../components/GlobalSidebar";
import AnnouncementBanner from "../../components/AnnouncementBanner";

export default function AdminHomePage() {
  const content = (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <Typography variant="h4" gutterBottom>
        Welcome to the Admin Dashboard
      </Typography>
      <Typography paragraph>
        Here you can manage users, monitor events, generate reports, and configure settings.
        This is your central hub for overseeing the entire PeerCampus platform.
      </Typography>
      <img
        src="https://s3.envato.com/files/639863406/05_preview.png"
        alt="dashboard banner"
        style={{
          width: "100%",
          borderRadius: "12px",
          marginBottom: "20px",
        }}
      />
      <Typography paragraph>
        Use the sidebar to navigate between different sections. The platform provides
        insightful analytics, role-based access, and tools to simplify your admin workflow.
      </Typography>
    </motion.div>
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <CssBaseline />
      <Navbar />

      <Box sx={{ display: "flex", flexGrow: 1 }}>
        <GlobalSidebar />

        {/* Main Content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            bgcolor: "background.default",
            p: 3,
            mt: "64px",
          }}
        >
          <Container>
            <Box sx={{ mb: 2 }}>
              <AnnouncementBanner />
            </Box>
            {content}
          </Container>
        </Box>
      </Box>

      <PostLoginFooter />
    </Box>
  );
}
